<template>
  <Modal class="period-modal" v-model="modalStatus" :transfer="false">
    <div slot="header">
      <h3>{{ ModalData.gamename }} - {{ action }}</h3>
    </div>
    <div class="ptable-table">
      <div v-if="ModalState == 1" class="ptable-tr" style="height: 35px">
        <div class="ptable-th">当前期数</div>
        <div class="ptable-td">
          <span v-if="ModalData.listPeriodData">
            {{ ModalData.listPeriodData.lastperiod }}
          </span>
        </div>
        <div class="ptable-th">赛事开奖时间</div>
        <div class="ptable-td">
          <span v-if="ModalData.listPeriodData">
            {{ ModalData.listPeriodData.lastendate }}
          </span>
        </div>
        <div class="ptable-th">剩余设定时间</div>
        <div class="ptable-td">
          <game-prop-timer
            v-if="
              showModal &&
              (ModalData.listPeriodData.lastendate || nowData.endate)
            "
            :data="{
              date: ModalData.listPeriodData.lastdate,
              endate: ModalData.listPeriodData.lastendate,
              codate: ModalData.listPeriodData.lastcodate,
              period: ModalData.listPeriodData.lastperiod,
              second: ModalData.listPeriodData.second,
            }"
            @trcolor="(val) => (nowTrColorStatus = val)"
            @checkTimeStatus="(val) => (nowTimeLodingStatus = val)"
          ></game-prop-timer>
        </div>
      </div>
      <div class="ptable-tr">
        <div class="ptable-th">输入期数</div>
        <div class="ptable-td">
          <Form
            v-if="ModalState === 1"
            ref="SettingFrom"
            class="keyinPeriod"
            :model="Setting"
            :rules="ruleSetting"
            inline
            @submit.native.prevent
          >
            <FormItem
              prop="Period"
              class="mb-0"
              style="vertical-align: middle; margin: auto"
            >
              <Icon
                type="md-play"
                size="24"
                @click="periodMath(-1)"
                style="vertical-align: middle; transform: rotateY(180deg)"
              />
              <Input
                style="width: 60.5%"
                v-if="ModalState === 1"
                v-model="Setting.Period"
                @on-change="chnagePeriod"
              ></Input>
              <Icon
                type="md-play"
                size="24"
                @click="periodMath(1)"
                style="vertical-align: middle"
              />
            </FormItem>
          </Form>
          <span v-if="ModalState === 2">
            {{ nowData.period }}
            <span v-if="ModalData.isNowPeriod">(当前期数)</span>
          </span>
          <div v-if="ModalState === 1" class="mt-4 mb-2">
            <div class="bold" style="font-size: 13px">选择开奖时间</div>
            <DatePicker
              confirm
              @on-ok="checkDate"
              type="datetime"
              v-model="selectDate"
              :clearable="false"
              style="width: 175px"
            />
          </div>
        </div>
        <div class="ptable-th">赛事开奖时间</div>
        <div class="ptable-td">
          <template v-if="!ExceedHeightPeriod">
            <span
              v-show="timeLodingStatus === 1"
              v-if="Setting.LastEndData || nowData.endate"
            >
              {{ ModalState === 1 ? Setting.LastEndData : nowData.endate }}
            </span>
            <span v-show="timeLodingStatus !== 1">
              {{
                checkCorssDate(
                  ModalState === 1 ? Setting.LastStart : nowData.date
                )
              }}
            </span>
          </template>
        </div>
        <div
          class="ptable-th"
          v-if="ModalState === 2 && this.nowData.period.length == 8"
        >
          距封盘时间
        </div>
        <div
          class="ptable-td"
          v-if="ModalState === 2 && this.nowData.period.length == 8"
        >
          <game-close-timer
            v-if="showModal && gameCloseTimerShow"
            :mathDate="nowData.codate"
          ></game-close-timer>
        </div>
        <div class="ptable-th">剩余设定时间</div>
        <div class="ptable-td">
          <game-prop-timer
            v-show="timeLodingStatus === 1 || timeLodingStatus === 2"
            v-if="showModal && (Setting.LastEndData || nowData.endate)"
            :data="{
              endate: ModalState === 1 ? Setting.LastEndData : nowData.endate,
              date: ModalState === 1 ? Setting.LastStart : nowData.date,
              period: ModalState === 1 ? Setting.Period : nowData.period,
              codate: ModalState === 1 ? Setting.LastCloseData : nowData.codate,
              second: ModalState === 1 ? null : nowData.second,
            }"
            @trcolor="(val) => (trColorStatus = val)"
            @checkTimeStatus="(val) => (timeLodingStatus = val)"
          ></game-prop-timer>
        </div>
      </div>
    </div>
    <component
      :is="componentsTable"
      ref="componentsTable"
      class="my-2"
      :data="nowData"
      :listPeriodData="ModalData.listPeriodData"
      :gameid="ModalData.gameid"
      :trColorStatus="trColorStatus"
      :timeLodingStatus="timeLodingStatus"
      :showModal="showModal"
      :ButtonRandomNumberShow.sync="ButtonRandomNumberShow"
      @changeButtonSendStatus="changeButtonSendStatus"
    ></component>
    <div class="text-right">
      <Button
        v-if="ButtonRandomNumberShow"
        type="warning"
        class="mr-2"
        @click="$refs.componentsTable.RandomNumber()"
        :disabled="timeLodingStatus === 2"
        :class="{ 'setting-disabled': timeLodingStatus === 2 }"
        >随机选号</Button
      >
      <Button
        type="primary"
        class="mr-2"
        @click="handleReset('SettingFrom')"
        :disabled="timeLodingStatus === 2"
        :class="{ 'setting-disabled': timeLodingStatus === 2 }"
        >清空输入</Button
      >
      <Button
        type="error"
        :disabled="
          nowData.GPMId === '*' ||
          ModalState === 1 ||
          timeLodingStatus === 2 ||
          ButtonSendStatus
        "
        :class="{
          'setting-disabled':
            nowData.GPMId === '*' ||
            ModalState === 1 ||
            timeLodingStatus === 2 ||
            ButtonSendStatus,
        }"
        @click="delMarkPeriod(nowData.GPMId)"
      >
        <Icon type="ios-alert" :size="16" />删除此期设定
      </Button>
    </div>
    <div slot="footer">
      <Button class="periodBtn" type="primary" @click="modalStatus = false"
        >取消</Button
      >
      <Button
        :disabled="ButtonSendStatus"
        :class="{ 'setting-disabled': ButtonSendStatus }"
        class="periodBtn"
        type="error"
        @click="ModalState === 1 ? handleSubmit('SettingFrom') : ClickSend()"
        :loading="SendLoading"
        >储存</Button
      >
    </div>
  </Modal>
</template>

<script>
import moment from "moment-timezone";
import { debounce } from 'debounce'
import { mapGetters } from 'vuex';
import delMarkPeriod from '@/mixins/del-mark-period'
const GamePropTimer = () => import('@/views/game-lobby/components/GamePropTimer')

const _pattern = /^[0-9]*$/
export default {
  components: {
    GamePropTimer,
    GameCloseTimer: () => import(/* webpackChunkName: "GameCloseTimer" */  './GameCloseTimer'),
    ModalTablePk10: () => import(/* webpackChunkName: "ModalTablePk10" */  './ModalTablePk10'),
    ModalTableQuick3: () => import(/* webpackChunkName: "ModalTableQuick3" */  './ModalTableQuick3'),
    ModalTableQuick10: () => import(/* webpackChunkName: "ModalTableQuick10" */  './ModalTableQuick10'),
    ModalTableSelect5: () => import(/* webpackChunkName: "ModalTableSelect5" */  './ModalTableSelect5'),
    ModalTableSixmark: () => import(/* webpackChunkName: "ModalTableSixmark" */  './ModalTableSixmark'),
    ModalTableLLto539: () => import(/* webpackChunkName: "ModalTableSixmark" */  './ModalTableLto539'),
    ModalTableSsc: () => import(/* webpackChunkName: "ModalTableSsc" */  './ModalTableSsc'),
    ModalTableSixmarkDaily: () => import(/* webpackChunkName: "ModalTableSixmarkDaily" */  './ModalTableSixmarkDaily'),
    ModalTableKeno: () => import(/* webpackChunkName: "ModalTableKeno" */  './ModalTableKeno'),
    ModalTableTcpl3: () => import(/* webpackChunkName: "ModalTableKeno" */  './ModalTableTcpl3'),
  },
  mixins: [delMarkPeriod],
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    ModalState: { // 1: 新增, 2: 修改
      type: Number,
    },
    ModalData: {
      type: Object
    }
  },
  data () {
    const validateCheckCode = (rule, value, callback) => {
      const lastperiod = this.ModalData.listPeriodData.lastperiod
      const status = this.checkInput(value, lastperiod, true)
      status ? callback(new Error(status)) : callback()
    };
    return {
      selectDate: '', // 使用者选择开奖时间
      timeLoop: null,
      timeLoding: null,
      ButtonSendStatus: false,
      SendLoading: false,
      Setting: {
        Period: '',  // 期数
        LastStart: null, // 赛事开始时间
        LastEndData: null, // 赛事开奖时间
        LastCloseData: null, // 賽事關盤時間
      },
      ruleSetting: {
        Period: [
          { type: 'string', message: '错误：请输入正确期数', pattern: _pattern, trigger: 'blur' },
          { validator: validateCheckCode, trigger: 'blur' },
        ]
      },
      PropClasses: { // 新增时使用的各玩法Table
        1: 'ModalTableSixmark',
        2: 'ModalTablePk10',
        3: 'ModalTableSsc',
        4: 'ModalTableQuick10',
        5: 'ModalTablePk10',
        6: 'ModalTableSelect5',
        8: 'ModalTableQuick3',
        9: 'ModalTableSixmark',
        10: 'ModalTableKeno',
        12: 'ModalTableTcpl3',
        15: 'ModalTableLLto539'
      },
      trColorStatus: false, // 输入的期数
      timeLodingStatus: 0, // 输入的期数
      nowTrColorStatus: false, // 当前期数
      nowTimeLodingStatus: 0, // 当前期数
      heightPeriod: 0, // 该游戏最高的期数
      ExceedHeightPeriod: false,
      ButtonRandomNumberShow: true, // 随机选号状态
    }
  },
  computed: {
    ...mapGetters(['getmember']),
    nowData () {
      if (!this.ModalData.GPMId) return {}
      return this.ModalData.markDataList.find(it => it.GPMId === this.ModalData.GPMId)
    },
    action () {// 判斷 新增或是修改狀態
      return this.ModalState === 1 ? '新增' : '修改'
    },
    componentsTable () { // 取得遊戲群組使用哪個元件
      if (!this.ModalData.gameGroupId) return
      if (this.ModalData.listPeriodData.betSeconds >= 86400 && this.ModalState === 2) return 'ModalTableSixmarkDaily'

      const gameGroupId = this.ModalData.gameGroupId
      return this.PropClasses[gameGroupId]
    },
    modalStatus: {
      get () {
        return this.showModal
      },
      set (val) {
        this.$emit('update:showModal', val)
      }
    },
    gameCloseTimerShow () {
      return this.ModalData.listPeriodData.lastperiod == this.nowData.period
    }
  },
  watch: {
    modalStatus (val) {
      window.setTimeout(() => {
        if (val && this.ModalState === 2) {
          // this.$refs.componentsTable.SetNumberMark(this.nowData)
        } else {
          this.handleReset('SettingFrom');
        }
      }, 200)
    },
    nowTimeLodingStatus (val) { // 当前期数非倒数状态时，传游戏id给父层
      if (val != 1) {
        this.$emit('now-modal-game', this.ModalData.gameid)
      }
    }
  },
  mounted () {
    this.MathRaceTime()
  },
  methods: {
    MathRaceTime () { // 計算 赛事开奖时间, 最高的期数
      if (!Object.keys(this.ModalData).length) return
      const status = this.checkInput(this.Setting.Period, this.ModalData.listPeriodData.lastperiod) // 判断输入的期数
      const date = this.Setting.Period.slice(0, 8) // 切割日期
      const betSeconds = this.ModalData.listPeriodData.betSeconds
      if (status || !moment(date).isValid()) return this.Setting.LastEndData = null // 判断是否為期数的格式
      if (this.Setting.Period.length == 8 && betSeconds >= 25200) {
        const enddatetime = moment(this.ModalData.listPeriodData.lastendate).format('HH:mm:ss')
        const datetime = moment(this.ModalData.listPeriodData.lastdate).format('HH:mm:ss')
        this.Setting.LastEndData = moment(date).format(`YYYY-MM-DD ${enddatetime}`)
        this.Setting.LastStart = moment(date).format(`YYYY-MM-DD ${datetime}`)
        this.Setting.LastCloseData = moment(this.Setting.LastEndData).subtract(15, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        return
      }
      if (this.Setting.Period.length !== 12 || !Object.keys(this.ModalData).length) return
      const number = this.Setting.Period.slice(8, 12) // 切割期數
      let zero = moment(date).format('YYYY-MM-DD 00:00:00')

      let startValue = moment(zero).valueOf() + ((Number(number) - 1) * 1000) * betSeconds // 計算預計开始時間
      let valueOf = moment(zero).valueOf() + (Number(number) * 1000) * betSeconds // 計算預計開獎時間
      this.Setting.LastStart = moment(startValue).format('YYYY-MM-DD HH:mm:ss')
      this.Setting.LastEndData = moment(valueOf).format('YYYY-MM-DD HH:mm:ss')
      this.Setting.LastCloseData = moment(this.Setting.LastEndData).subtract(15, 'seconds').format('YYYY-MM-DD HH:mm:ss')
      // 计算该游戏一天最高几期
      let tomorrowData = moment(moment(date).add(1, 'days').format('YYYY-MM-DD 00:00:00')).valueOf()
      this.heightPeriod = (tomorrowData - moment(zero).valueOf()) / 1000 / this.ModalData.listPeriodData.betSeconds
      this.ExceedHeightPeriod = Number(number) > this.heightPeriod
    },
    checkDate () {
      let val = this.selectDate
      this.$refs['SettingFrom'].resetFields()
      if (moment(val - moment()._d).valueOf() < 0) {
        this.$Message.error('您选择的时间已开奖')
        this.Setting.Period = ''
        this.chnagePeriod()
        return
      }
      let diff = moment(val - moment().startOf('day')._d).valueOf() / 1000
      let diffDays = Math.floor(diff / 86400)
      let diffPeriod = (diff % 86400) / this.ModalData.listPeriodData.betSeconds
      let keyinPeriod = moment().add(diffDays, 'days').format('YYYYMMDD')
      if (this.ModalData.gameid != 23 && this.ModalData.gameid != 16 && this.ModalData.gameid != 34) { // GC、12六合彩期數格式不同
        keyinPeriod += this.periodSet(diffPeriod)
        if (keyinPeriod == this.ModalData.listPeriodData.lastperiod) keyinPeriod = (Number(keyinPeriod) + 1).toString()
      }
      this.Setting.Period = keyinPeriod
      this.chnagePeriod()
    },
    handleSubmit (name) { // 判断期数input是否正确无错误提示
      this.$refs[name].validate((valid) => {
        if (valid) this.ClickSend()
      })
    },
    handleReset (name) { // 清除
      if (this.ModalState === 1) {
        this.$refs[name].resetFields()
        this.trColorStatus = false
        this.timeLodingStatus = 0
      }
      this.Setting.LastEndData = null
      this.Setting.LastCloseData = null
      this.selectDate = ''
      this.$refs.componentsTable.removeNumber()
    },
    delAction () {
      this.modalStatus = false
      this.$emit('reload')
    },
    chnagePeriod: debounce(function (val) { // 輸入期數後計算該期數時間
      this.MathRaceTime()
    }, 200),
    async ClickSend () {
      try {
        this.SendLoading = true
        const mark = this.$refs.componentsTable.GetNumberMark()
        const postState = this.ModalState === 1 || this.nowData.GPMId === '*'
        const rtp = this.$refs.componentsTable.GetRTP()
        const obj = {
          loid: this.getmember.pid,
          mark: mark,
          rtp
        }

        if (postState) {
          obj.gameid = this.ModalData.gameid
          obj.period = this.nowData.GPMId === '*' ? this.nowData.period : this.Setting.Period
        } else {
          obj.GPMId = this.nowData.GPMId
          obj.period = this.nowData.period
        }
        const res = postState
          ? await this.$axios.gameLobby.addGamePeriodMark(obj)
          : await this.$axios.gameLobby.updGamePeriodMark(obj)
        if (res.status === 1) {
          this.$Message.success('成功')
          this.modalStatus = false
          this.$emit('reload')
        }
        this.SendLoading = false
      } catch (error) {
        console.error(error);

        this.SendLoading = false
      }
    },
    changeButtonSendStatus (value) {
      this.ButtonSendStatus = value
    },
    periodMath (val) {
      let newPeriod
      if (Number(this.Setting.Period) == 0) {
        newPeriod = Number(this.ModalData.listPeriodData.lastperiod) + 1
      } else {
        if (Number(this.Setting.Period) + val <= Number(this.ModalData.listPeriodData.lastperiod)) {
          this.$Message.error('不可小于当前期数')
          newPeriod = Number(this.ModalData.listPeriodData.lastperiod) + 1
        } else {
          newPeriod = Number(this.Setting.Period) + val
        }
      }
      this.Setting.Period = newPeriod.toString()
      this.chnagePeriod()
    },
    periodSet (val) {
      let period = (Math.ceil(val)).toString()
      switch (4 - period.length) {
        case 1:
          period = '0' + period
          break;
        case 2:
          period = '00' + period
          break;
        case 3:
          period = '000' + period
          break;
      }
      return period
    },
    checkCorssDate (value) {
      let result = ''
      switch (this.timeLodingStatus) {
        case 3:
          result = '(跨日期数)'
          break;
        case 2:
          if (this.nowData.period.length > 8) {
            result = '(设定时间已过)'
          } else {
            result = value
          }
          break;
        default:
          break;
      }
      return result
    },
    /**
     * 判断输入的参数 给予错误提示
     * lastState 状态开啟后可判断: 一天一期六合彩系列、该期数已超过计算后游戏一天最高的期数
     */
    checkInput (value, lastperiod, lastState) {
      const datalist = this.ModalData.markDataList
      let result = ''
      if (!value || value.length < 1) {
        result = '错误：请勿留空'
      } else if (value.length != lastperiod.length || !_pattern.test(value)) {
        result = '错误：请输入正确期数'
      } else if (value == lastperiod) {
        result = '错误：此为当前期数'
      } else if (value < lastperiod) {
        result = '错误：设定期数已过'
      } else if (datalist.some(it => it.period == value)) {
        result = '错误：期数已重复'
      } else if (lastState && this.ModalData.listPeriodData.betSeconds !== 25200 && Number(value.slice(8, 12)) > this.heightPeriod) {
        result = '错误：错误的期数格式'
      }
      return result
    }
  }
}
</script>

<style lang="scss">
.period-modal .ivu-modal {
  width: 70% !important;
  .ivu-select-not-found {
    color: #ff0000;
  }
}

.ptable-table {
  display: table;
  border-collapse: collapse;
  width: 100%;
  height: 35px;
  text-align: center;
  margin-bottom: 40px;
}
.ptable-tr {
  display: table-row;
  border: solid 1px #7893c7;
}
.ptable-th {
  display: table-cell;
  width: 10%;
  background: #1d3c78;
  color: #ffffff;
  vertical-align: middle;
  font-weight: bold;
}
.ptable-td {
  width: 15%;
  display: table-cell;
  vertical-align: middle;
}

.periodBtn {
  height: auto;
  padding: 6px 13px;
}

.period-modal {
  .ivu-icon-md-play {
    min-width: 25px;
    cursor: pointer;
    &:active {
      font-size: 20px !important;
    }
  }
}

.keyinPeriod {
  .ivu-form-item-error-tip {
    padding: 0px;
    width: 100%;
  }
}
</style>